<template>
    <basic-container id="warehouseconsumable">
        <avue-crud
                     v-if="reWrite"
                   :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                     @row-update="rowUpdate"
                     @row-save="rowSave"
                     @row-del="rowDel"
                     @search-change="searchChange"
                     @search-reset="searchReset"
                     @selection-change="selectionChange"
                     @current-change="currentChange"
                     @size-change="sizeChange"
                     @on-load="onLoad"
                     @refresh-change="onLoad"
                     :upload-preview="uploadPreview"
                     :upload-before="uploadBefore"
                     :before-close="beforeClose"
        >
          <template slot-scope="scope" slot="menu">
              <el-button
                v-if="permission.warehouseconsumable_delete"
                type="text"
                icon="el-icon-thumb"
                size="small"
                @click.native="
              switchFormButtonHandler(scope.row.id, scope.row.status)
            "
              >{{ scope.row.status > 0 ? "停用" : "启用" }}
              </el-button>
            </template>
          <template slot="menuLeft">
            <el-button type="danger"
                       size="small"
                       icon="el-icon-circle-close"
                       plain
                       v-if="permission.warehouseconsumable_delete"
                       @click="handleDelete">停 用
            </el-button>
          </template>
          <template slot-scope="{ row }" slot="status">
            <el-tag :type="row.status === 1 ? 'success' : 'danger'">
              {{ row.status === 0 ? '停用' : '正常' }}</el-tag
            >
          </template>
          <template slot-scope="{ row }" slot="measuringUnitName">
              {{ getMeasuringUnitName(row.measuringUnit)}}
          </template>
          <template slot-scope="{ row }" slot="conversionUnit">
              {{ getMeasuringUnitName(row.conversionUnit)}}
          </template>
          <template slot="typeIdForm">
              <el-select
                style="width: 100%"
                v-model="selectTypeObj.name"
                ref="typeSelect"
                placeholder="请选择 物料类型"
              >
                <el-option>
                  <el-tree
                    ref="typeTree"
                    :data="treeData"
                    :props="typeTreeProps"
                    node-key="name"
                    check-strictly
                    check-on-click-node
                    :expand-on-click-node="false"
                    @node-click="typeClick"
                  >
                  </el-tree>
                </el-option>
            </el-select>
          </template>
          <template slot="fullCodeForm">
              <el-input :value="(selectTypeObj.fullCode + form.code)" disabled></el-input>
          </template>
          <template slot="attachIdsForm" slot-scope="scope">
            <VUpload
              :disabled="fileDisabled"
              message="提示：只能上传jpg/png文件，且"
              messageType="pre"
              :types="['jpg', 'png']"
              :limit="1"
              :fileList.sync="attachList"
            ></VUpload>
          </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import VUpload from '@/views/components/v-upload.vue';
    import {add, getDetail, getList, remove, update} from "@/api/crmedical/warehouse/warehouseconsumable";
    import {mapGetters} from "vuex";
    import {getProjectList} from "@/api/crmedical/project/project";
    import { Base64 } from 'js-base64';
    import settings from '@/config/vd-settings';
    import { getToken } from '@/util/auth';
    import {getAttachByMainIdList} from "@/api/crmedical/attach/attach";
    import {tree,treeFree} from "@/api/crmedical/warehouse/warehouseconsumabletype";
    import {getProjectDict} from "@/api/crmedical/project-dictionary/project-dictionary";

    export default {
      components: { VUpload },
      data: function () {
        return {
          // 分类树的数据
          treeData: [],
          // 物料类型树的节点属性
          typeTreeProps: {
            label: 'name',
            children: 'children',
            isLeaf: 'isLeaf',
            disabled: 'disabled',
          },
          // 当前选择的物料类型
          selectTypeObj: {
            fullCode: '',
          },
          headers:{},
          form: {},
          query: {},
          loading: true,
          page: {
            pageSize: 10,
            currentPage: 1,
            total: 0
          },
          selectionList: [],
          firstDisplayFlag:false,
          reWrite: false,
          tempProjectId: '',
          projectList:[],
          attachList: [],
          fileDisabled: false,
          measuringUnitList:[],
          passCloseDialog:false,
          option: {
            height: 'auto',
            calcHeight: 100,
            tip: false,
            border: true,
            index: true,
            viewBtn: true,
            delBtn: false,
            selection: true,
            columnBtn: false,
            refreshBtn: false,
            stripe:true,
            dialogClickDialog:false,
            column: [
              {
                label: "项目名称",
                prop: "projectId",
                type: 'tree',
                cascaderItem: ['type'],
                hide: true,
                showColumn: false,
                editDisabled: true,
                addDisabled: true,
                viewDisabled: true,
                order: 1,
                search: true,
                dicUrl: '/api/v4ward/project/getProjectList',
                props: { label: 'name', value: 'id' },
                rules: [{
                  required: true,
                  message: "请选择项目名称",
                  trigger: "blur"
                }]
              },
              {
                label: "物料类型",
                prop: "typeName",
                editDisplay: false,
                addDisplay: false,
              },
              {
                label: "物料类型",
                prop: "type",
                type: 'tree',
                dicUrl: 'api/v4ward/warehouse/consumable/type/treeFree?projectId={{key}}',
                props: { label: 'name', value: 'id' },
                dicData: [],
                search: true,
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                hide: true,
              },
              {
                label: "物料编码",
                prop: "code",
                search: true,
                maxlength: 30,
                showWordLimit: true,
                overHidden: true,
                rules: [
                  { pattern: /^[a-zA-Z0-9]+$/i, message: '请输入数字或字母' },
                  {
                  required: true,
                  message: "请输入物料编号",
                  trigger: "blur"
                }]
              },
              {
                label: "完整编码",
                prop: "fullCode",
                hide: true,
                showColumn: false,
                formslot: true,
              },
              {
                label: "物料名称",
                prop: "name",
                search: true,
                maxlength: 30,
                showWordLimit: true,
                overHidden: true,
                order: 1,
                rules: [{
                  required: true,
                  message: "请输入物料名称",
                  trigger: "blur"
                }]
              },
              {
                label: "物料类型",
                prop: "typeId",
                hide: true,
                formslot: true,
                viewDisplay: false,
                order: 1,
                rules: [{
                  required: true,
                  message: "请输入物料类型",
                  trigger: "blur"
                }]
              },

              {
                label: "规格型号",
                prop: "specification",
                maxlength: 100,
                showWordLimit: true,
                overHidden: true,
                rules: [{
                  required: true,
                  message: "请输入规格型号",
                  trigger: "blur"
                }]
              },
              {
                label: "生产厂商",
                prop: "manufacturer",
                maxlength: 30,
                showWordLimit: true,
                overHidden: true,
                hide: true,
                showColumn: false,
              },
              {
                label: "品牌",
                prop: "brand",
                maxlength: 30,
                showWordLimit: true,
                overHidden: true,
                hide: true,
                showColumn: false,
              },
              {
                label: "计量单位",
                prop: "measuringUnitName",
                slot: true,
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
              },
              {
                label: "计量单位",
                prop: "measuringUnit",
                type: 'tree',
                dataType: 'string',
                dicData: [],
                hide: true,
                props: {
                  label: "dictValue",
                  value: "dictKey",
                },
                rules: [{
                  required: true,
                  message: "请输入计量单位",
                  trigger: "blur"
                }]
              },
              {
                label: "换算单位",
                prop: "conversionUnit",
                slot: true,
                type: 'tree',
                dataType: 'string',
                dicData: [],
                props: {
                  label: "dictValue",
                  value: "dictKey",
                },
              },
              {
                label: "换算比例",
                prop: "conversionRatio",
                rules: [
                  { pattern: /^[1-9]\d*$/, message: '请输入正整数' },
                ]
              },
              {
                label: "排序",
                prop: "sort",
                maxlength: 6,
                showWordLimit: true,
                hide: true,
                showColumn: true,
                rules: [
                  { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入自然数' },
                  {
                    required: true,
                    message: "请输入排序号",
                    trigger: "blur"
                  }]
              },
              {
                label: "备注",
                prop: "description",
                type: 'textarea',
                span: 24,
                row: 4,
                maxlength: 300,
                showWordLimit: true,
                overHidden: true,
                hide: true,
                showColumn: true,
              },
              {
                label: "状态",
                prop: "status",
                type: "switch",
                slot: true,
                align:"center",
                addDisplay: false,
                viewDisplay: false,
                editDisplay: false,
                dataType: 'number',
                props: { label: 'dictValue', value: 'dictKey' },
              },
              {
                label: '图片',
                prop: 'fileUrl',
                type: 'upload',
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
              },
              {
                label: '图片',
                prop: 'attachIds',
                formslot: true,
                hide: true,
                span: 24,
              },
            ]
          },
          data: []
        };
      },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.warehouseconsumable_add, false),
                    viewBtn: this.vaildData(this.permission.warehouseconsumable_view, false),
                    delBtn: this.vaildData(this.permission.warehouseconsumable_delete, false),
                    editBtn: this.vaildData(this.permission.warehouseconsumable_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
      created() {
        this.headers['Authorization'] = `Basic ${Base64.encode(
          `${settings.clientId}:${settings.clientSecret}`
        )}`;
        // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
        this.headers['Blade-Auth'] = 'bearer ' + getToken();

        //加载列表
        getProjectList({}).then((res) => {
          this.projectList = res.data;
          if (this.projectList.length > 0) {
            this.query.projectId = this.projectList[0].id;
            this.tempProjectId = this.projectList[0].id;
            treeFree({projectId:this.tempProjectId}).then(({ data }) => {
              const dataType = this.findObject(this.option.column,'type');
              dataType.dicData = data;
            });
          }
          this.$nextTick(() => {
            this.reWrite = true;
            setTimeout(()=>{
              this.$refs.crud.$children[1].$children[4].$el.addEventListener("click", ()=>{
                    
                    if(this.option.height == this.bodyHeight - 368){
                      this.option.height = this.bodyHeight - 250
                    }else{
                      this.option.height = this.bodyHeight - 368;
                    }
                    this.$refs.crud.getTableHeight();
                });
              })
        
        });
        this.option.height = this.bodyHeight - 368;
          this.firstDisplayFlag = true;
        });


      },
      watch: {
        'form.projectId'() {
          if(this.form.projectId){
            this.form.measuringUnit = '';
            this.form.conversionUnit = '';
            this.form.typeId = '';

            getProjectDict({projectId:this.form.projectId,code:'project_consumable_measuring_unit'}).then(({ data }) => {
              const dataType = this.findObject(this.option.column,'measuringUnit');
              const dataType2 = this.findObject(this.option.column,'conversionUnit');
              if(data.length>0){
                dataType.dicData = data;
                dataType2.dicData = data;
              }else {
                dataType.dicData =["1"];
                dataType2.dicData =["1"];
              }

            });
          }
        },

      },
        methods: {
          /* 点击分类树的节点 */
          typeClick(data) {
            this.form.typeId = data.id;
            this.selectTypeObj = data;
            this.$refs.typeTree.setCheckedNodes([data]);
            this.$refs.typeSelect.blur();
          },
          getMeasuringUnitName(measuringUnitId){
            let name = '';
            this.measuringUnitList.forEach(function (value, index, array) {
              if (value.dictKey == measuringUnitId) {
                name = value.dictValue;
                return;
              }
            });
            return name;
          },
          beforeClose(done,type){
            if(this.passCloseDialog){
              done();
              return;
            }else{
              this.$confirm("确定关闭？", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              ).then(()=>{
             
               this.attachList =  [];
            this.form = [];
            this.fileDisabled = false;
            done();
              })
            }

            
          },
          
          uploadBefore(file, done, loading) {
            let len = file.name.split('.').length;
            console.log(file.type === 'image/jpeg' || file.type === 'image/png');
            console.log(file.type);
            const isImage =
              (file.name.split('.')[len - 1] === 'png' || file.name.split('.')[len - 1] === 'jpg') &&
              (file.type === 'image/jpeg' || file.type === 'image/png');
            console.log(isImage);
            const isLt5MB = file.size / 1024 < 5000;
            if (!isImage) {
              this.$message.error('只能上传jpg/png格式的图片');
              loading();
              return;
            }
            if (!isLt5MB) {
              this.$message.error('上传图片大小不能超过5MB!');
              loading();
              return;
            }
            if (isImage && isLt5MB) {
              done();
            }
          },
          switchFormButtonHandler(id,status){
            let text = '';
            if (status === 1) {
              text =  '是否确定停用选中物料?';
            }else {
              text =  '是否确定启用选中物料?';
            }
            this.$confirm(text, {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                return remove({ids: id,status: status,});
              })
              .then(() => {
                this.$message.success('操作成功!');
                this.$refs.crud.toggleSelection();
                this.onLoad();
              });
          },
          getProjectNameById(projectId) {
            let projectName = '';
            this.projectList.forEach(function (value, index, array) {
              if (value.id === projectId) {
                projectName = value.name;
                return;
              }
            });
            return projectName;
          },
            rowSave(row, loading, done) {
              let arrs = this.attachList.map(item => {
                return item.id;
              });
              row.attachIds = arrs.join(',');
              row.fileUrl = '';
              console.log(row);
                add(row).then(() => {
                  this.passCloseDialog = true;
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowUpdate(row, index, loading, done) {
              let arrs = this.attachList.map(item => {
                return item.id;
              });
              row.attachIds = arrs.join(',');
              row.fileUrl = '';
                update(row).then(() => {
                  this.passCloseDialog = true;
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowDel(row) {
                this.$confirm("是否确定停用选中物料?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("是否确定停用选中物料?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids,status: 1,});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
          findOptionById(tree, targetId) {
            // 遍历树的每个节点
            for (const node of tree) {
              // 判断当前节点是否为目标选项
              if (node.id === targetId) {
                return node; // 找到目标选项，返回节点对象
              }
              // 如果当前节点有子节点，则递归调用findOptionById函数继续查找
              if (node.children) {
                const result = this.findOptionById(node.children, targetId);
                if (result) {
                  return result; // 找到目标选项，返回节点对象
                }
              }
            }
            // 遍历完所有节点仍未找到目标选项，返回null
            return null;
          },
          async beforeOpen(done, type) {
            if(type=='view'){
              this.passCloseDialog = true;
            }else{
              this.passCloseDialog = false;
            }
            if (['edit', 'add'].includes(type)) {
              // 每次都重新获取分类树，因为分类的状态可能发生了变化
              await tree({
                projectId: type == 'edit' ? this.form.projectId : this.query.projectId,
              }).then((res) => {
                this.treeData = res.data;
              });
            }
            if (["edit", "view"].includes(type)) {
              getAttachByMainIdList({mainId:this.form.id}).then(({data}) => {
                if (data.length>0){
                  data.forEach(item=>{
                    item.url = item.link;
                  })
                  this.attachList = data;
                }
              });
              if (["view"].includes(type)) {
                console.log('查看')
                this.fileDisabled = true;
              }
              let typeName = this.form.typeName;
              getDetail({id:this.form.id}).then(({data}) => {
                data.typeName = typeName;
                this.form = data;
                console.log('-----dd',this.form)
                if (type == 'edit') {
                  // 遍历 treeData 树状结构，找到选中的分类
                  this.selectTypeObj = this.findOptionById(this.treeData, this.form.typeId);
                }
              });
            }else {
              // 完整编码需要用到code和$typeId，为了进行监听需要先声明
              this.form = {
                projectId: this.query.projectId,
                code: '',
                $typeId: '',
              }
            }
            done();
          },
          searchReset() {
            this.query.name = '';
            this.query.code = '';
            this.query.typeId = '';
            this.query.type = '';
            this.firstDisplayFlag = true;
            this.onLoad();
          },
          searchChange(params,done) {
            this.query = params;
            this.page.currentPage = 1;
            this.onLoad();
            done();
          },
          selectionChange(list) {
            this.selectionList = list;
          },
          selectionClear() {
            this.selectionList = [];
            this.$refs.crud.toggleSelection();
          },
          currentChange(currentPage) {
            this.page.currentPage = currentPage;
          },
          sizeChange(pageSize) {
            this.page.pageSize = pageSize;
          },
            onLoad(page) {
                page = page || this.page;
                this.loading = true;
              if (!this.query.projectId ) {
                this.query.projectId = this.tempProjectId;
              }
              if (this.query.type ) {
                this.query.typeId = this.query.type;
              }
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                  this.tempProjectId = this.query.projectId;
                  this.page.total = data.total;
                  this.data = data.records;
                  this.data.forEach(item=>{
                    item.measuringUnitNmae = item.measuringUnit;
                  });
                  getProjectDict({projectId:this.tempProjectId,code:'project_consumable_measuring_unit'}).then(({ data }) => {
                    this.measuringUnitList = data;
                  });
                  this.loading = false;
                  this.selectionClear();
                  if (this.firstDisplayFlag) {
                    let ent = document.querySelector('input[placeholder="项目名称"]');
                    ent.value = this.getProjectNameById(this.query.projectId);
                    this.tempProjectId = this.query.projectId;
                    //关闭默然显示，重刷页面时才开启默认显示
                    this.firstDisplayFlag = false;
                  }
                });
            }
        }
    };
</script>

<style scoped>
  ::v-deep .avue-form__menu--center{
    text-align: right;
  }
  ::v-deep .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
  
</style>
<style >
#warehouseconsumable .el-table .cell{
    white-space: inherit;
  }
</style>
